
























































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IOrganizations, IUssdCallback, PayloadState } from '@/types/types';

@Component({ name: 'UssdCallbackDialog' })
export default class UssdCallbackDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => [] }) organizations!: IOrganizations[];
  @Prop({ default: null }) callback!: IUssdCallback | null;

  valid: boolean = false;
  form: any = this.emptyForm();

  rules = {
    required: (value: string) => !!value || 'This field is required',
    url: (value: string) => /^https?:\/\/.+/.test(value) || 'Must be a valid http(s) URL',
  };

  get isEditing(): boolean {
    return !!this.callback;
  }

  emptyForm() {
    return {
      serviceCode: '',
      shortCode: '',
      callbackUrl: '',
      ussdVersion: 'LATEST',
      organizationId: null,
    };
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    this.form = this.callback
      ? {
          serviceCode: this.callback.serviceCode,
          shortCode: this.callback.shortCode,
          callbackUrl: this.callback.callbackUrl,
          ussdVersion: this.callback.ussdVersion,
          organizationId: this.callback.organizationId || null,
        }
      : this.emptyForm();
    (this.$refs.form as Vue & { resetValidation: () => void })?.resetValidation();
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('save')
  save() {
    // editing only sends mutable fields; service/short code identify the registration
    return this.isEditing
      ? {
          id: this.callback!._id,
          body: {
            callbackUrl: this.form.callbackUrl,
            ussdVersion: this.form.ussdVersion,
            ...(this.form.organizationId && { organizationId: this.form.organizationId }),
          },
        }
      : { body: { ...this.form, organizationId: this.form.organizationId || undefined } };
  }
}
